module.exports = __webpack_public_path__ + "img/saler.360e2fa5.png";